import React from 'react'
import { IonCol, IonIcon, IonLabel, IonRow } from '@ionic/react'
import RolloverBox from '../../../../../../components/rolloverBox/RolloverBox.component'
import { chevronBackOutline, chevronForwardOutline } from 'ionicons/icons'
import { getBurnsSelector } from '../../selectors'
import { useSelector } from 'react-redux'
import { IBurnsState } from '../../store/burns.types'
import { useTranslation } from 'react-i18next'

const BurnsSummary = () => {
  const burnsStateData: IBurnsState = useSelector(getBurnsSelector)
  const {
    headAnterior,
    headPosterior,
    armsAnterior,
    armsPosterior,
    legsAnterior,
    legsPosterior,
    trunkAnterior,
    trunkPosterior,
    tbsaScore,
    firstDegree,
    secondDegree,
    thirdDegree,
  } = burnsStateData

  const { t } = useTranslation()

  const Box1 = (
    <div className='body-surface-area'>
      <h1 className='primary body-percentage'>
        {tbsaScore}
        {'%'}
      </h1>
      <p className='total-body-surface-area'>{t('burns.TotalBodySurfaceArea')}</p>
    </div>
  )

  const Box2: React.FC = () => {
    return (
      <div className='rollover-box-content'>
        <IonRow className='rollover-box-item'>
          <IonCol className='rollover-box-item-label p-0'>{t('burns.TBSA')}</IonCol>
          <IonCol className='d-flex justify-content-end primary p-0'>
            {tbsaScore}
            {'%'}
          </IonCol>
        </IonRow>
        <IonRow className='rollover-box-item'>
          <IonCol className='rollover-box-item-label p-0'>1st : </IonCol>
          <IonCol className='d-flex justify-content-end primary p-0'>
            {firstDegree}
            {'%'}
          </IonCol>
        </IonRow>
        <IonRow className='rollover-box-item'>
          <IonCol className='rollover-box-item-label p-0'>2nd : </IonCol>
          <IonCol className='d-flex justify-content-end primary p-0'>
            {secondDegree}
            {'%'}
          </IonCol>
        </IonRow>
        <IonRow className='rollover-box-item'>
          <IonCol className='rollover-box-item-label p-0'>3rd : </IonCol>
          <IonCol className='d-flex justify-content-end primary p-0'>
            {thirdDegree}
            {'%'}
          </IonCol>
        </IonRow>
      </div>
    )
  }

  const sideSectionAnterior = (
    <IonRow>
      <IonCol>
        <IonRow>
          <IonCol className='pl-0'>
            <IonLabel className='d-flex burns-sidebar-headings'>{t('burns.Front')}</IonLabel>
          </IonCol>
          <hr className='w-100 bg-divider m-0' />
        </IonRow>
        <IonRow>
          <IonCol className='ion-no-padding'>
            <IonLabel className='burns-sidebar-text fw-500'>{t('burns.Head')}</IonLabel>
          </IonCol>
          <IonCol className='d-flex justify-content-end ion-no-padding'>
            <IonLabel className='burns-sidebar-text fw-400'>
              {headAnterior}
              {'%'}
            </IonLabel>
          </IonCol>
          <hr className='w-100 bg-divider m-0' />
        </IonRow>
        <IonRow>
          <IonCol className='ion-no-padding'>
            <IonLabel className='burns-sidebar-text fw-500'>{t('burns.Arms')}</IonLabel>
          </IonCol>
          <IonCol className='d-flex justify-content-end ion-no-padding'>
            <IonLabel className='burns-sidebar-text fw-400'>
              {armsAnterior}
              {'%'}
            </IonLabel>
          </IonCol>
          <hr className='w-100 bg-divider m-0' />
        </IonRow>
        <IonRow>
          <IonCol className='ion-no-padding'>
            <IonLabel className='burns-sidebar-text fw-500'>{t('burns.Trunks')}</IonLabel>
          </IonCol>
          <IonCol className='d-flex justify-content-end ion-no-padding'>
            <IonLabel className='burns-sidebar-text fw-400'>
              {trunkAnterior}
              {'%'}
            </IonLabel>{' '}
          </IonCol>
          <hr className='w-100 bg-divider m-0' />
        </IonRow>
        <IonRow>
          <IonCol className='ion-no-padding'>
            <IonLabel className='burns-sidebar-text fw-500'>{t('burns.Legs')}</IonLabel>
          </IonCol>
          <IonCol className='d-flex justify-content-end ion-no-padding'>
            <IonLabel className='burns-sidebar-text fw-400'>
              {legsAnterior}
              {'%'}
            </IonLabel>{' '}
          </IonCol>
        </IonRow>
      </IonCol>
    </IonRow>
  )

  const sideSectionPosterior = (
    <IonRow className='w-100'>
      <IonCol>
        <IonRow>
          <IonCol className='pl-0'>
            <IonLabel className='burns-sidebar-headings'>{t('burns.Back')}</IonLabel>
          </IonCol>
          <hr className='w-100 bg-divider m-0' />
        </IonRow>
        <IonRow>
          <IonCol className='ion-no-padding'>
            <IonLabel className='burns-sidebar-text fw-500'>{t('burns.Head')}</IonLabel>
          </IonCol>
          <IonCol className='d-flex justify-content-end ion-no-padding'>
            <IonLabel className='burns-sidebar-text fw-400'>
              {headPosterior}
              {'%'}
            </IonLabel>
          </IonCol>
          <hr className='w-100 bg-divider m-0' />
        </IonRow>
        <IonRow>
          <IonCol className='ion-no-padding'>
            <IonLabel className='burns-sidebar-text fw-500'>{t('burns.Arms')}</IonLabel>
          </IonCol>
          <IonCol className='d-flex justify-content-end ion-no-padding'>
            <IonLabel className='burns-sidebar-text fw-400'>
              {armsPosterior}
              {'%'}
            </IonLabel>
          </IonCol>
          <hr className='w-100 bg-divider m-0' />
        </IonRow>
        <IonRow>
          <IonCol className='ion-no-padding'>
            <IonLabel className='burns-sidebar-text fw-500'>{t('burns.Trunks')}</IonLabel>
          </IonCol>
          <IonCol className='d-flex justify-content-end ion-no-padding'>
            <IonLabel className='burns-sidebar-text fw-400'>
              {trunkPosterior}
              {'%'}
            </IonLabel>
          </IonCol>
          <hr className='w-100 bg-divider m-0' />
        </IonRow>
        <IonRow>
          <IonCol className='ion-no-padding'>
            <IonLabel className='burns-sidebar-text fw-500'>{t('burns.Legs')}</IonLabel>
          </IonCol>
          <IonCol className='d-flex justify-content-end ion-no-padding'>
            <IonLabel className='burns-sidebar-text fw-400'>
              {legsPosterior}
              {'%'}
            </IonLabel>
          </IonCol>
        </IonRow>
      </IonCol>
    </IonRow>
  )

  return (
    <IonRow className='p-10'>
      <IonCol size='3' className='p-0'>
        {sideSectionAnterior}
      </IonCol>
      <IonCol size='6' className='p-0 d-flex justify-content-center'>
        <RolloverBox
          swipeBackContent={<IonIcon slot='start' className='medium' icon={chevronBackOutline} />} //in case there are more than 2 pages and we need to go back
          size={{ width: '157px', height: '128px' }}
          className='custom-rollover-box'
          pages={[
            {
              color: 'light-blue',
              customStyle: 'hide-scrollbar',
              content: Box1,
              swipeNextContent: (
                <div className='primary mr-8 burn-measure-details'>
                  {t('burns.BurnMeasureDetails')}
                  <IonIcon slot='start' className='primary' icon={chevronForwardOutline} />
                </div>
              ),
            },
            { color: 'light-blue', customStyle: 'hide-scrollbar', content: <Box2 /> },
            // Add more pages as needed
          ]}
        />
      </IonCol>
      <IonCol size='3' className='p-0'>
        <IonRow>{sideSectionPosterior}</IonRow>
      </IonCol>
    </IonRow>
  )
}

export default BurnsSummary
